export const ServerToClientEvents = {
  CONNECTION: 'connect',
  SessionMutated: 'session mutated',
  JobUpdated: 'job updated',
  JobLog: 'job log',
  BuildUpdated: 'build started',
  MemberUpdated: 'member updated',
  DeploymentUpdated: 'deployment updated',
  ArcRoleUpdated: 'arc role updated',
  ArcGroupImportUpdated: 'arc group import updated',
  ArcRoleImportUpdated: 'arc role import updated'
};

/** This rename is just to reduce repeated text in the interface below. */
const e = ServerToClientEvents;

/**
 * Map of event names to the typeof the event listeners.
 */